
import { PERMISSIONS } from '@/utils/rbac'

export const MENU_SECTIONS = [
    {
        id: 'overview',
        title: 'Overview',
        items: [
            { to: '/dashboard', label: 'Dashboard', icon: 'dashboard', pageId: 'dashboard', permission: PERMISSIONS.VIEW_DASHBOARD, requireNotSuperAdmin: true },
            { to: '/superadmin-dashboard', label: 'Super Admin', icon: 'shield', permission: PERMISSIONS.VIEW_SUPERADMIN_DASHBOARD },
            { to: '/superadmin-dashboard?tab=settings', label: 'System Settings', icon: 'settings', permission: PERMISSIONS.VIEW_SUPERADMIN_DASHBOARD },
        ]
    },
    {
        id: 'attendance',
        title: 'Attendance',
        items: [
            { to: '/attendance', label: 'Attendance', icon: 'clock', pageId: 'attendance', requireNotSuperAdmin: true },
            { to: '/attendance-history', label: 'History', icon: 'history', pageId: 'history', requireNotSuperAdmin: true },
            { to: '/attendance-tracking', label: 'Tracking', icon: 'tracking', pageId: 'tracking', permission: PERMISSIONS.TRACK_ATTENDANCE, requireNotSuperAdmin: true },
            { to: '/staff-activity-log', label: 'Staff Activity', icon: 'history', pageId: 'staff-activity', permission: PERMISSIONS.TRACK_ATTENDANCE, requireNotSuperAdmin: true },
            { to: '/attendance-calendar', label: 'Calendar', icon: 'calendar', pageId: 'calendar', permission: PERMISSIONS.TRACK_ATTENDANCE, requireNotSuperAdmin: true },
            { to: '/time-adjustments', label: 'Time Adjustments', icon: 'clock', pageId: 'time-adjustments', permission: PERMISSIONS.TRACK_ATTENDANCE, requireNotSuperAdmin: true },
        ]
    },
    {
        id: 'workforce',
        title: 'Workforce',
        items: [
            { to: '/employee-management', label: 'Employees', icon: 'users', pageId: 'employees', permission: PERMISSIONS.MANAGE_EMPLOYEES, requireNotSuperAdmin: true },
            { to: '/performance-kpi', label: 'Performance & KPI', icon: 'star', pageId: 'performance', permission: PERMISSIONS.MANAGE_EMPLOYEES, requireNotSuperAdmin: true },
            { to: '/role-management', label: 'Role Management', icon: 'shield', pageId: 'roles', permission: PERMISSIONS.MANAGE_ROLES, requireNotSuperAdmin: true },
            { to: '/employee-face-registration', label: 'Face Registration', icon: 'face-scan', pageId: 'face-registration', permission: PERMISSIONS.REGISTER_FACES, requireNotSuperAdmin: true },
        ]
    },
    {
        id: 'scheduling',
        title: 'Scheduling',
        items: [
            { to: '/roster-management', label: 'Roster', icon: 'clipboard', pageId: 'roster', permission: PERMISSIONS.MANAGE_ROSTER, requireNotSuperAdmin: true },
            { to: '/task-scheduling', label: 'Task Scheduler', icon: 'task', pageId: 'task-scheduler', requireNotSuperAdmin: true },
            { to: '/task-board', label: 'Task Board', icon: 'task-board', pageId: 'task-board', requireNotSuperAdmin: true },
            { to: '/my-roster', label: 'My Roster', icon: 'clipboard', pageId: 'my-roster', requireNotManager: true, requireNotSuperAdmin: true },
            { to: '/shift-management', label: 'Shifts', icon: 'schedule', pageId: 'shifts', permission: PERMISSIONS.MANAGE_SHIFTS, requireNotSuperAdmin: true },
        ]
    },
    {
        id: 'leave',
        title: 'Leave',
        items: [
            { to: '/leave-management', label: 'Leave Management', icon: 'leave', pageId: 'leave-management', permission: PERMISSIONS.MANAGE_LEAVE, requireNotSuperAdmin: true },
            { to: '/leave-request', label: 'Leave Request', icon: 'calendar', pageId: 'leave-request', requireNotSuperAdmin: true },
        ]
    },
    {
        id: 'organization',
        title: 'Organization',
        items: [
            { to: '/branch-management', label: 'Branches', icon: 'branches', pageId: 'branches', permission: PERMISSIONS.MANAGE_BRANCHES, requireNotSuperAdmin: true },
            { to: '/announcements', label: 'Announcements', icon: 'speaker', pageId: 'announcements', permission: PERMISSIONS.VIEW_ANNOUNCEMENTS, requireNotSuperAdmin: true },
            { to: '/payroll-export', label: 'Payroll', icon: 'payroll', pageId: 'payroll', permission: PERMISSIONS.MANAGE_PAYROLL, requireNotSuperAdmin: true },
            { to: '/sales-profit-payroll', label: 'Sales Profit', icon: 'payroll', salesProfit: true },
            { to: '/payroll-rules', label: 'Payroll Rules', icon: 'payroll', payrollRules: true },
            { to: '/holiday-management', label: 'Public Holidays', icon: 'calendar', pageId: 'holidays' },
        ]
    },
    {
        id: 'system',
        title: 'System',
        items: [
            { to: '/ai-assistant', label: 'AI Assistant', icon: 'sparkles', requiredEmail: 'work.kuzafri@gmail.com' },
            { to: '/alerts', label: 'Alerts', icon: 'bell', pageId: 'alerts', permission: PERMISSIONS.VIEW_ALERTS, requireNotSuperAdmin: true },
            { to: '/attendance-settings', label: 'Settings', icon: 'settings', pageId: 'settings', permission: PERMISSIONS.MANAGE_SETTINGS },
            { to: '/profile', label: 'My Profile', icon: 'user', pageId: 'profile' },
        ]
    }
]
